// 该文件用于创建应用路由器
import { createRouter, createWebHistory } from 'vue-router'

const home = () => import("../pages/HomePage.vue")
const login = () => import("../pages/LoginPage.vue")
const register = () => import("../pages/RegisterPage.vue")
const user = () => import("../pages/UserCenterPage.vue")
const course = () => import("../pages/CourseCenterPage.vue")
const course_detail = () => import("../pages/CourseDetailPage.vue")
const payment = () => import("../pages/PaymentPage.vue")
const news = () => import("../pages/NewsCenterPage.vue")
const news_detail = () => import("../pages/NewsDetailPage.vue")
const about = () => import("../pages/AboutUsPage.vue")
const organization = () => import("../pages/organization/jbxx.vue")

const routes = [
    {
        path: "/",
        name: "Home",
        component: home
    },
    {
        path: "/home",
        redirect: "/"
    },
    {
        path: "/login",
        name: "Login",
        component: login
    },
    {
        path: "/register",
        name: "Register",
        component: register
    },
    {
        path: "/user",
        name: "UserCenter",
        component: user,
    },
    {
        path: "/course",
        name: "CourseCenter",
        component: course,
        props(route) {
            return {
                filters: [route.query.filter]
            };
        }
    },
    {
        path: "/coursedetail",
        name: "CourseDetail",
        component: course_detail,
    },
    {
        path: "/payment",
        name: "Payment",
        component: payment,
    },
    {
        path: "/news",
        name: "NewsCenter",
        component: news,
    },
    {
        path: "/newsdetail",
        name: "NewsDetail",
        component: news_detail,
    },
    {
        path: "/about",
        name: "AboutUs",
        component: about,
    },
    {
        path: '/organization/jbxx',
        component:  () => import('../Layout/index.vue'),
        children: [
            {
                path: '/organization/jbxx',
                component: () => import('../pages/organization/jbxx.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '机构中心',
                    type: "organization"
                }
            },
            {
                path: '/organization/cwxx',
                component: () => import('../pages/organization/cwxx.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '财务信息',
                    type: "organization"
                }
            },
            {
                path: '/organization/cklb',
                component: () => import('../pages/organization/cklb.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '课程讲师列表',
                    type: "organization"
                }
            },
            {
                path: '/organization/cjkc',
                component: () => import('../pages/organization/cjkc.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '创建课程',
                    type: "organization"
                }
            },
            {
                path: '/organization/sxkc',
                component: () => import('../pages/organization/sxkc.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '已上线课程',
                    type: "organization"
                }
            },
            {
                path: '/organization/kcpf',
                component: () => import('../pages/organization/kcpf.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '课程评分管理',
                    type: "organization"
                }
            },
            {
                path: '/organization/kcjs',
                component: () => import('../pages/organization/kcjs.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '课程结算管理',
                    type: "organization"
                }
            },
            {
                path: '/organization/editPhone',
                component: () => import('../pages/organization/editPhone.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '修改手机号',
                    type: "organization"
                }
            },
            {
                path: '/organization/editInfo',
                component: () => import('../pages/organization/editInfo.vue'),
                meta: {
                    isAuthenticated: true,
                    title: '修改信息',
                    type: "organization"
                }
            },
        ]
    },
    {
        path: "/organization/jbxx",
        name: "Organization",
        component: organization,
    },
    {
        path: "/organization/cwxx",
        name: "cwxx",
        component: () => import('../pages/organization/cwxx.vue'),
    },
    {
        path: "/organization/cklb",
        name: "cklb",
        component: () => import('../pages/organization/cklb.vue'),
    },
    {
        path: "/organization/cjkc",
        name: "cjkc",
        component: () => import('../pages/organization/cjkc.vue'),
    },
    {
        path: "/organization/kcjs",
        name: "kcjs",
        component: () => import('../pages/organization/kcjs.vue'),
    },
    {
        path: "/organization/kcpf",
        name: "kcpf",
        component: () => import('../pages/organization/kcpf.vue'),
    },
    {
        path: "/organization/sxkc",
        name: "sxkc",
        component: () => import('../pages/organization/sxkc.vue'),
    },
    {
        path: "/organization/khyq",
        name: "khyq",
        component: () => import('../pages/organization/khyq.vue'),
    },
    {
        path: "/organization/qdgl",
        name: "courserSign",
        component: () => import('../pages/organization/qdgl.vue'),
    },
    {
        path: "/organization/ckmd",
        name: "ckmd",
        component: () => import('../pages/organization/ckmd.vue'),
        title:'参课名单'
    },
    {
        path: "/organization/sxckmd",
        name: "sxckmd",
        component: () => import('../pages/organization/sxckmd.vue'),
        title:'参课名单'
    },
    {
        path: "/organization/xxgw",
        name: "xxgw",
        component: () => import('../pages/organization/xxgw.vue'),
        title:'学习感悟'
    },
    {
        path: "/organization/jsd",
        name: "jsd",
        component: () => import('../pages/organization/jsd.vue'),
        title:'结算单'
    },
    {
        path: "/organization/ddlb",
        name: "ddlb",
        component: () => import('../pages/organization/ddlb.vue'),
        title:'订单列表'
    },
    {
        path: "/organization/addKc",
        name: "addKc",
        component: () => import('../pages/organization/addKc.vue'),
        title:'创建线上课程'
    },
    {
        path: "/organization/addxxKc",
        name: "addxxKc",
        component: () => import('../pages/organization/addxxKc.vue'),
        title:'创建线下课程'
    },
    {
        path: "/organization/editPhone",
        name: "editPhone",
        component: () => import('../pages/organization/editPhone.vue'),
        title:'修改手机号'
    },
    {
        path: "/organization/editInfo",
        name: "editInfo",
        component: () => import('../pages/organization/editInfo.vue'),
        title:'修改信息'
    },
    {
        path: "/organization/gwlb",
        name: "editInfo",
        component: () => import('../pages/organization/gwlb.vue'),
        title:'感悟列表'
    },
    {
        path: "/organization/previewVideo",
        name: "previewVideo",
        component: () => import('../pages/organization/previewVideo.vue'),
        title:'视频播放器'
    },
];
const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_PATH),
    linkActiveClass: 'active',
    routes,
    // route切换时滚动到顶部
    scrollBehavior() {
        return { top: 0 }
    }
});

export default router;
